import './clm-content-preview.scss';

import { isEmpty } from 'lodash';
import { arrayOf, object, string } from 'prop-types';
import React from 'react';
import { Card, CardFooter } from 'reactstrap';

import Image from '../../generic/Image';
import Preview from '../../generic/Preview';
import { clmContentPreviewTypes } from '../constants';
import { sanitizeId, transformClmContentPreview } from './utils';

function ClmContentPreview({
  clmContentPreview,
  contentfulCreatives,
  categories,
  productTag,
  countryCode,
  gender,
}) {
  if (isEmpty(clmContentPreview)) return null;
  const transformedClmContentPreview = transformClmContentPreview(
    clmContentPreview,
    contentfulCreatives,
    countryCode,
    gender,
    productTag,
    categories,
  );

  function thumbnail(type, contentId, url, index) {
    const isVideo = type === clmContentPreviewTypes.video;
    const src = isVideo ? '/images/video_thumb.jpg' : url;
    const safeContentId = sanitizeId(contentId);
    const key = `thumb-${safeContentId}-${type}-${index}`;

    return (
      <>
        <Image className="clm-card" id={key} src={src} alt={url} />
        <Preview target={key} src={url} />
      </>
    );
  }

  const renderContentPreview = (contentId, contentName, data, type) =>
    data.map((item, index) => (
      <li className="list-inline-content-id-preview" key={item.id}>
        <Card>
          {thumbnail(type, contentId, item.url, index)}
          <CardFooter className="px-2 py-1 bg-white text-muted small text-center">
            {contentName}
          </CardFooter>
        </Card>
      </li>
    ));

  return (
    <div className="mt-3 d-flex overflow-auto">
      {transformedClmContentPreview.map(
        ({ contentId, contentName, coverImageData, coverVideoData }) => (
          <ul key={contentId} className="list-unstyled list-inline mb-0">
            {coverImageData.length > 0 &&
              renderContentPreview(
                contentId,
                contentName,
                coverImageData,
                clmContentPreviewTypes.image,
              )}
            {coverVideoData.length > 0 &&
              renderContentPreview(
                contentId,
                contentName,
                coverVideoData,
                clmContentPreviewTypes.video,
              )}
          </ul>
        ),
      )}
    </div>
  );
}
ClmContentPreview.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  clmContentPreview: object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contentfulCreatives: arrayOf(object.isRequired).isRequired,
  categories: arrayOf(string.isRequired).isRequired,
  productTag: string.isRequired,
  countryCode: string.isRequired,
  gender: string.isRequired,
};

export default ClmContentPreview;
